export default "__VITE_ASSET__DV4Dc6qJ__"